import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import close from "../assets/close.svg";
import BackArrow from "../common/BackArrow";
import { StatsContext } from "../contexts/StatsContext";
import API from "../common/Api";
import { connect } from "react-redux";
import IndividualBookingDetails from "./IndividualBookingDetails";
import GroupBookingDetails from "./GroupBookingDetails";

const mapStateToProps = (state) => ({
  headers: { headers: state.headers() },
  business: state.business,
  userProfile: state.userProfile,
});

export default connect(mapStateToProps)(
  class Booking_details extends Component {
    static contextType = StatsContext;
    state = {
      id: this.props.id,
      booking: false,
      // Group session data from route state
      groupData: this.props.location?.state || null
    };

    componentDidMount = () => {
      this.getBooking();
    };

    getBooking = () => {
      API.get(
        `business/appointments/${this.props.id}`,
        this.props.headers
      ).then(({ data: { data } }) =>
        this.setState({ booking: data })
      );
    };

    render() {
      const { booking, groupData } = this.state;

      const isNotOwnerAccountType = this.props.userProfile.account_type === 'business_team_member';
      const hideClientContactFromEmployee = booking?.business?.['booking-settings']?.hide_client_contact_details_from_employees;

      const isOwner = !isNotOwnerAccountType;
      const canEmployeeSeeContact = !hideClientContactFromEmployee;
      const showClientContact = isOwner || canEmployeeSeeContact;

      // Determine if this is a group session
      const isGroupSession = booking?.is_group_session || booking?.services?.[0]?.is_group_session;

      // Get bookings array for group sessions (prefer fresh API data over route state)
      const groupBookings = booking?.bookings || groupData?.bookings || [];

      return (
        <div className="dsk-modal-rapper">
          <NavLink
            className="absolute-bg"
            to={{ pathname: "/bookings" }}
          ></NavLink>

          <div id="dsk-modal" className="dsk-modal booking-details container">
            {window.innerWidth >= 600 && (
              <NavLink
                className="close-btn wrapper dsk"
                to={{ pathname: "/bookings" }}
              >
                <img src={close} alt="" srcSet="" />
              </NavLink>
            )}

            <div className="wrapper">
              <div className="section-header flex space-btw">
                <p className="section-title flex center">
                  <BackArrow className="mbl" /> Booking details
                </p>
              </div>

              {booking ? (
                <div className="card">
                  {isGroupSession ? (
                    <GroupBookingDetails
                      booking={booking}
                      groupData={groupData}
                      groupBookings={groupBookings}
                      showClientContact={showClientContact}
                      isOwner={isOwner}
                      headers={this.props.headers}
                    />
                  ) : (
                    <IndividualBookingDetails
                      booking={booking}
                      business={this.props.business}
                      headers={this.props.headers}
                      showClientContact={showClientContact}
                      onRefresh={this.getBooking}
                    />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  }
);
